import PaginationControls from "../../../../../../components/base/PaginationControls";

interface GroupPaginationProps {
  currentPage: number;
  totalPages: number;
  isDarkMode: boolean;
  onPageChange: (page: number) => void;
}

export function GroupPagination({
  currentPage,
  totalPages,
  onPageChange,
}: GroupPaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <PaginationControls
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
    />
  );
}
